import React, { useEffect, useRef } from 'react'
import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Grid
} from '@mui/material'

import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness'
import PostAddIcon from '@mui/icons-material/PostAdd'

import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import moment from 'moment'

import { CustomTitle } from '../../../common/CustomTitle/CustomTitle'
import { CustomTable } from '../../../common/Tables/CustomTable/CustomTable'
import { GoBack } from '../../../common/GoBack/GoBack'

import { DynamicProfileDetails } from '../DynamicProfileDetails/DynamicProfileDetails'
import { defaultPanelsDynamicProfile as model } from '../DefaultPanelsDynamicProfile/DefaultPanelsDynamicProfile'

import { panelsDynamicProfilesActive } from '../../../../reducers/dynamicLighting/panelsDynamicProfilesReducer'
import {
  startPanelsDynamicProfilesActive,
  startPanelsDynamicProfilesLoad
} from '../../../../reducers/dynamicLighting/panelsDynamicProfilesActions'

import customTheme from '../../../../material-ui/theme'

export const CreateDynamicProfileScreen = () => {
  const isMounted = useRef(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { profiles, active } = useSelector(state => state.panelsDynamicProfiles)

  const columns = [
    { id: 'id', label: 'ID' },
    { id: 'name', label: 'Nombre' },
    { id: 'date', label: 'Fecha' }
  ]

  const handleProfileClick = id => {
    dispatch(startPanelsDynamicProfilesActive(id))
  }

  const handleDefaultProfile = () => {
    dispatch(panelsDynamicProfilesActive(model))
    navigate('/dynamic-lighting/profiles/panels/create')
  }

  const handleUseProfile = () => {
    const profile = {
      ...active,
      name: ''
    }

    delete profile.id
    delete profile.contract_id
    delete profile.contract_name
    delete profile.date
    delete profile.status_flag

    dispatch(panelsDynamicProfilesActive(profile))
    navigate('/dynamic-lighting/profiles/panels/create')
  }

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true
    }

    dispatch(startPanelsDynamicProfilesLoad())

    return () => {
      isMounted.current = false
    }
  }, [dispatch])

  return (
    <Container
      maxWidth={false}
      sx={{
        p: 2
      }}
    >
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          sx={{
            display: 'flex'
          }}
        >
          <GoBack to='/dynamic-lighting/profiles' />

          <CustomTitle
            title={`${'Crear perfil de iluminación dinámica'} ~ ${'Centros de mando'}`}
            icon={
              <Avatar>
                <SettingsBrightnessIcon />
              </Avatar>
            }
          />
        </Grid>

        <Grid
          container
          sx={{
            justifyContent: 'center',
            mt: 1
          }}
        >
          <Grid item xs={12} md={6}>
            <Card>
              <CardHeader
                avatar={
                  <Avatar aria-label='PostAddIcon'>
                    <PostAddIcon />
                  </Avatar>
                }
                title={'¿Desea crear un nuevo perfil a partir de otro preexistente?'}
                subheader={'Seleccione un perfil del listado o bien continúe con los valores por defecto'}
              />

              {active && (
                <>
                  <Divider />

                  <CardContent>
                    <DynamicProfileDetails profile={active} />
                  </CardContent>

                  <Divider />
                </>
              )}

              <CardContent
                sx={{
                  cursor: 'pointer'
                }}
              >
                <CustomTable
                  rows={profiles.map(profile => ({
                    ...profile,
                    date: profile.date
                      ? moment(profile.date).format('DD MMM yyyy HH:mm')
                      : '',
                    _onClick: handleProfileClick
                  }))}
                  columns={columns}
                />
              </CardContent>

              <CardActions
                sx={{
                  gap: 1,
                  flexWrap: 'wrap'
                }}
              >
                <Button
                  color='inherit'
                  variant='contained'
                  onClick={handleDefaultProfile}
                >
                  {'Continuar con los valores por defecto'}
                </Button>

                {active && (
                  <Button
                    variant='contained'
                    onClick={handleUseProfile}
                    sx={{
                      backgroundColor: customTheme.palette.primary.main,
                      color: customTheme.palette.secondary.main,
                      '&:hover': {
                        backgroundColor: customTheme.palette.primary.main,
                        opacity: 0.85
                      }
                    }}
                  >
                    {'Crear nuevo perfil a partir de ' + active.name}
                  </Button>
                )}
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}